import { render, staticRenderFns } from "./regsit.vue?vue&type=template&id=8ef7631c&scoped=true&"
import script from "./regsit.vue?vue&type=script&lang=js&"
export * from "./regsit.vue?vue&type=script&lang=js&"
import style0 from "./regsit.vue?vue&type=style&index=0&id=8ef7631c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef7631c",
  null
  
)

export default component.exports